"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
exports.default = vue_1.default.extend({
    name: 'username-recovered',
    props: {},
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        },
    },
    methods: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        recoveredUsername() {
            var usernameRecoveredChallenge = this.$store.state.currentChallenge;
            return usernameRecoveredChallenge.RecoveredUsername || '';
        },
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    mounted() {
        this.$refs.usernameRecovered.focus();
    },
    components: {
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
        ContainerSlide: ContainerSlide_vue_1.default,
    },
});
